const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

// Single source of truth for cart line item property keys used by the plan
// purchase flow (IMEI + province + E911 pairing). Names are FINAL, confirmed
// by Ztar's Rana in writing 28 Aug 2026 (see docs/specs/imei-province-e911-spec.md)
// — not placeholders. Governs internal/pairing keys only; customer-facing
// display properties (e.g. the plan line's "Province"/"Billing" subtitle
// text, read by sections/main-cart-items.liquid + speakout-cart-line-province-subtitle.liquid)
// are a separate, intentionally human-readable category and are not part of
// this object. Rename here only; every internal read/write site references
// this object, never a literal string.
const LINE_PROPERTY_KEYS = {
  imei: 'imei',
  province: 'province',
  // Internal linkage key pairing an E911 fee line to its plan line.
  // Underscore-prefixed so the theme's existing cart property display
  // filters (main-cart-items.liquid, cart-drawer.liquid) hide it automatically.
  planLink: '_plan_line_key'
};

// Single source of truth for the cart-attribute keys Ztar reads off every
// plan-purchase order (docs/specs/imei-province-e911-spec.md). Names are
// FINAL, confirmed by Ztar's Rana in writing 28 Aug 2026 — not placeholders.
// intent/billingProvince/imei are read by Ztar directly; the other two are
// ours only (Ztar ignores them), kept unprefixed anyway since a cart
// attribute's double-underscore prefix hides it from the order too, and all
// 5 must reach the order. Written via /cart/add.js's own `attributes` key
// (not documented by Shopify, but proven working in this app already — see
// assets/cart.js's applyReconciliation, which already reads one of these
// back off a cart built exactly that way). Separate from LINE_PROPERTY_KEYS
// above — a cart attribute is cart-scoped and cannot express per-line E911
// pairing, so both objects exist side by side, never merged.
const CART_ATTRIBUTE_KEYS = {
  intent: 'intent',
  billingProvince: 'billingProvince',
  imei: 'imei',
  provinceName: 'speakout_province_name',
  deviceCheck: 'speakout_device_check'
};
